import {ReactNode} from "react";

import {useHiddenPricesRegistrationHandler} from "../../hooks/use_hidden_prices_registration_handler";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useApplicationModalButtonAmplitudeOpenTracking} from "../hooks/use_application_modal_button_amplitude_open_tracking";
import {AmplitudeLeadFormLocation} from "../tracking/amplitude/get_amplitude_form_location";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";
import {ApplicationModalButton, IApplicationModalButtonRenderProps} from "./ApplicationModalButton";

export interface IApplicationModalButtonWithHiddenPricesRenderProps extends IApplicationModalButtonRenderProps {
    handleClick: () => void;
    priceRevealButtonTestId?: string;
}

type IProps = {
    render: (props: IApplicationModalButtonWithHiddenPricesRenderProps) => ReactNode;
    shouldShowPrice: boolean;
    gtmData: IGTMEventLeadForm;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeFormLocation?: AmplitudeLeadFormLocation;
    entryCtaLabel?: string;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "trackingMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButtonWithHiddenPrices = (props: IProps) => {
    const {render, shouldShowPrice, gtmData, amplitudePlacement, amplitudeFormLocation, entryCtaLabel, ...applicationModalButtonProps} = props;

    const {getOpenModalTracking} = useApplicationModalButtonAmplitudeOpenTracking({
        vendorId: applicationModalButtonProps.vendorId,
        offerId: applicationModalButtonProps.offerId,
        propertyId: applicationModalButtonProps.propertyId,
        source: applicationModalButtonProps.source,
        sourceSection: applicationModalButtonProps.sourceSection,
        ctaText: gtmData.clickText,
        formLocation: amplitudeFormLocation
    });

    return (
        <ApplicationModalButton
            {...applicationModalButtonProps}
            amplitudePlacement={amplitudePlacement ?? undefined}
            render={({openModal, isOpened}) => {
                const {handleClick} = useHiddenPricesRegistrationHandler({
                    onAction: () => {
                        openModal(getOpenModalTracking(gtmData));
                    },
                    shouldShowPrice,
                    gtmData,
                    propertyId: applicationModalButtonProps.propertyId,
                    offerId: applicationModalButtonProps.offerId,
                    vendorId: applicationModalButtonProps.vendorId,
                    leadSource: applicationModalButtonProps.source,
                    leadSourceSection: applicationModalButtonProps.sourceSection,
                    amplitudePlacement,
                    entryCtaLabel
                });

                return render({openModal, isOpened, handleClick});
            }}
        />
    );
};
import {ReactNode} from "react";

import {useHiddenPricesRegistrationHandler} from "../../hooks/use_hidden_prices_registration_handler";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useApplicationModalButtonAmplitudeOpenTracking} from "../hooks/use_application_modal_button_amplitude_open_tracking";
import {AmplitudeLeadFormLocation} from "../tracking/amplitude/get_amplitude_form_location";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";
import {ApplicationModalButton, IApplicationModalButtonRenderProps} from "./ApplicationModalButton";

export interface IApplicationModalButtonWithHiddenPricesRenderProps extends IApplicationModalButtonRenderProps {
    handleClick: () => void;
    priceRevealButtonTestId?: string;
}

type IProps = {
    render: (props: IApplicationModalButtonWithHiddenPricesRenderProps) => ReactNode;
    shouldShowPrice: boolean;
    gtmData: IGTMEventLeadForm;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeFormLocation?: AmplitudeLeadFormLocation;
    entryCtaLabel?: string;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "trackingMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButtonWithHiddenPrices = (props: IProps) => {
    const {render, shouldShowPrice, gtmData, amplitudePlacement, amplitudeFormLocation, entryCtaLabel, ...applicationModalButtonProps} = props;

    const {getOpenModalTracking} = useApplicationModalButtonAmplitudeOpenTracking({
        vendorId: applicationModalButtonProps.vendorId,
        offerId: applicationModalButtonProps.offerId,
        propertyId: applicationModalButtonProps.propertyId,
        source: applicationModalButtonProps.source,
        sourceSection: applicationModalButtonProps.sourceSection,
        ctaText: gtmData.clickText,
        formLocation: amplitudeFormLocation
    });

    return (
        <ApplicationModalButton
            {...applicationModalButtonProps}
            amplitudePlacement={amplitudePlacement ?? undefined}
            render={({openModal, isOpened}) => {
                const {handleClick} = useHiddenPricesRegistrationHandler({
                    onAction: () => {
                        openModal(getOpenModalTracking(gtmData));
                    },
                    shouldShowPrice,
                    gtmData,
                    propertyId: applicationModalButtonProps.propertyId,
                    offerId: applicationModalButtonProps.offerId,
                    vendorId: applicationModalButtonProps.vendorId,
                    leadSource: applicationModalButtonProps.source,
                    leadSourceSection: applicationModalButtonProps.sourceSection,
                    amplitudePlacement,
                    entryCtaLabel
                });

                return render({openModal, isOpened, handleClick});
            }}
        />
    );
};
